<template>
    <div class="obs-modal-container">
        <div class="modal-form-container">
            <div class="title-box">
                <h2>{{ getString('alguma_observacao') }}</h2>
            </div>
            <div class="product-info-wrapper">
                <div class="image-container">
                    <img v-if="obsModalProd.subItemProductImages && obsModalProd.subItemProductImages.large != null" :src="getImagesURL(obsModalProd, 'subItemProductImages', 'large')" alt="">
                    <img v-else :src="noImageSrc">
                </div>

                <div class="name-container" v-if="obsModalProd.subItemName">
                    <h2 v-text="getProductLanguage(obsModalProd, 'subItemName')"></h2>
                </div>
            </div>

            <div class="details-container" v-if="obsModalProd.subItemDescription">
                <p v-text="'Descrição: ' + getProductLanguage(obsModalProd, 'subItemDescription')"></p>
            </div>

            <div class="observations-container" id="observations-container">
                <div class="observations-group-container" v-for="(obsGroup, key) in obsModalProd.subItemObservationsChoice" :key="key">
                    <span class="grupo-op-name">
                        <span v-text="getProductLanguage(obsGroup, 'subItemObsGroupName')"></span>
                        <span v-text="`${selectedObs.length || 0} / ${obsModalProd.subItemObservationsChoice[key].maxQuantity || (obsGroup.subItemObservations || []).length}`"></span>
                    </span>
                    <div class="min-observations-message" v-if="obsGroup.minQuantity > 0" :class="{'red-text': selectedObs.length < obsGroup.minQuantity}">{{ getMessageObservationsMinQuantity(obsGroup.minQuantity) }}</div>
                    <div class="obs-item-container">
                        <div class="item-obs" v-for="(obs, key2) in removeBlockedProdsObs(obsGroup.subItemObservations)" :key="key2">
                            <div class="container-input" v-if="(obsModalProd.subItemObservationsChoice[key].maxQuantity !== 1)">
                                <input class="styled-input" :id="'child-item-obs' + key2 + obs.subItemObsCode" type="checkbox" :value="obs" v-model="selectedObs" @change="validateObs(obs, $event)" >
                                <span class="checkmark"></span>
                            </div>
                            <div class="container-input" v-else>
                                <input class="styled-input" :id="'child-item-obs' + key2 + obs.subItemObsCode" type="radio" :value="obs" v-model="selectedObs" @change="validateObs(obs, $event)" >
                                <span class="checkmark radio"></span>
                            </div>
                            <label :for="'child-item-obs' + key2 + obs.subItemObsCode" >
                                <span v-text="getProductLanguage(obs, 'subItemObsName')"></span>
                                <span v-if="obs.price" v-text="` + ${formatMoney(obs.price)}`"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <!-- Observação Digitada -->
                <div class="observations-group-container" v-if="exibeObsDigitada">
                    <span class="grupo-op-name">
                        <span>{{ getString('observacao_livre') }}</span>
                    </span>
                    <!-- <textarea v-model="typedObs" class="typed-obs-text" id="typed-obs" rows="5" maxlength="25" @focus="show" ></textarea> -->
                    <div id="typed-obs-modal" ref="typedObsModalDiv" class="div-input-android" @click="editObs"></div>
                </div>
                <div id="keyboard-filler" v-if="editingObs"></div>
            </div>
        </div>

        <div v-if="checkMinObs()" class="prod-item-footer">
            <DefaultButton :text="getString('sem_observacao')" outlined="true" @defaultBtnClick="modalCancel"></DefaultButton>
            <DefaultButton :text="getString('confirmar')" @defaultBtnClick="modalConfirm"></DefaultButton>
        </div>
        <div v-else class="prod-item-footer" style="display: flex">
            <DefaultButton :text="getString('confirmar')" @defaultBtnClick="modalConfirm" :disabled="minObs"></DefaultButton>
        </div>

        <div class="keyboard-overlay" v-if="editingObs" @click="closeKeyboard"></div>
        <AndroidKeyboard id="android-keyboard" v-if="editingObs"
            :inputElement="inputElement"
            :layout="layout">
        </AndroidKeyboard>
        <!-- <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input" /> -->
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton'
import LocaleController from '@/assets/controllers/LocaleController'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import ClarityController from '@/assets/controllers/ClarityController'
export default {
    name: 'ObservationsModalGom',
    components: {
        DefaultButton,
        AndroidKeyboard
    },
    data () {
        return {
            inputElement: null,
            layout: keyboardLayout.TEXT,
            editingObs: false,
            selectedObs: [],
            noImageSrc: null,
            exibeObsDigitada: Util.getLocalConfigs('permiteObsDigitada'),
            typedObs: '',
            junk: require('../../static/icons/junk-icon.png'),
            minObs: true
        }
    },
    props: ['obsModalProd'],
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk
        this.obsModalProd.subItemObservationsChoice && this.obsModalProd.subItemObservationsChoice.forEach(obsGroup => {
            (obsGroup.subItemObservations || []).forEach(obs => {
                obs.subItemObsGroupCode = obsGroup.subItemObsGroupCode
            })
        })
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target

                if (!this.visible) {
                    this.visible = true
                }

                let obsContainer = document.getElementById('observations-container')
                setTimeout(() => {
                    obsContainer.scrollTo(0, obsContainer.scrollHeight)
                }, 100)
            }
        },
        hide: function () {
            this.visible = false
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
            // return Util.getLocalConfigs('urlIMGOdhenInterface')
        },
        modalCancel: function () {
            this.$emit('obsModalClose', this.obsModalProd)
        },
        modalConfirm: function () {
            this.obsModalProd.observations = (this.selectedObs && Array.isArray(this.selectedObs)) ? this.selectedObs : [this.selectedObs]
            this.obsModalProd.typedObs = this.typedObs.trim()
            this.obsModalProd.minObs = false
            ClarityController.event('usuario_selecionou_observacao')
            ClarityController.setTag('observacao_selecionada', this.obsModalProd.observations[0].subItemObsName)
            this.$emit('obsModalClose', this.obsModalProd)
        },
        formatMoney: function (price) {
            return Util.formatMoney(price)
        },
        validateObs: function (obs, clickEvent) {
            let obsGroup = this.obsModalProd.subItemObservationsChoice.find(element => element.subItemObsGroupCode === obs.subItemObsGroupCode)

            let maxObservations = obsGroup.maxQuantity || 0
            let minObservations = obsGroup.minQuantity || 0

            let groupSelectedObs = []

            if (this.selectedObs && this.selectedObs.length) {
                groupSelectedObs = this.selectedObs.filter(element => element.subItemObsGroupCode === obs.subItemObsGroupCode)
            }

            let groupObsNumber = (groupSelectedObs && groupSelectedObs.length) || 0
            let checkObsMax = ((maxObservations != null && maxObservations !== 0) && groupObsNumber > maxObservations && clickEvent.srcElement.checked)
            let checkObsMin = (minObservations === 0) || ((minObservations != null && minObservations !== 0) && groupObsNumber >= minObservations)
            if (checkObsMax) {
                this.selectedObs.pop()
                clickEvent.srcElement.checked = false
            }
            this.minObs = !checkObsMin
            this.$forceUpdate()
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        editObs: function () {
            this.inputElement = this.$refs.typedObsModalDiv
            this.editingObs = true

            let obsContainer = document.getElementById('observations-container')
            setTimeout(() => {
                obsContainer.scrollTo(0, obsContainer.scrollHeight)
            }, 100)
        },
        closeKeyboard: function () {
            this.editingObs = false
            this.typedObs = this.$refs.typedObsModalDiv.innerText
        },
        removeBlockedProdsObs: function (obs) {
            return Util.removeBlockedProdsObs(obs)
        },
        getMessageObservationsMinQuantity: function (minQuantity) {
            return this.getString('escolha_pelo_menos') + ' ' + minQuantity + ' ' + (minQuantity > 1 ? this.getString('observacoes') : this.getString('observacao')) + ' *'
        },
        checkMinObs: function () {
            let minObsGroup = true
            this.obsModalProd.subItemObservationsChoice.forEach(obsGroup => {
                if (obsGroup.minQuantity && obsGroup.minQuantity > 0) {
                    minObsGroup = false
                }
            })
            return minObsGroup
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    .obs-modal-container {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto 75px;
        background: @white;
        border-radius: 25px;
        z-index: 2;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        height: 1500px;
        display: grid;
        grid-template-rows: 1fr 180px;

        .modal-form-container {
            position: relative;
            overflow: hidden auto;
            display: flex;
            flex-direction: column;

            .title-box {
                background-color: @primary-color;
                height: 120px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 25px 25px 0px 0px;
                margin-bottom: 15px;

                h2 {
                    color: @white;
                    margin: auto;
                }
            }

            .image-container {
                padding: 20px;

                img {
                    height: 350px;
                    object-fit: scale-down;
                    margin: auto;
                    display: block;
                }
            }

            .name-container {
                margin: auto;
                display: block;
                margin-bottom: 50px;
                margin-left: 20px;
                margin-right: 20px;
                color: @primary-color;
                padding: 0 10px;
            }

            .details-container {
                padding: 15px 30px 15px 30px;
                display: flex;
                align-content: center;
                align-items: center;
                p {
                    padding: 0;
                }
            }

            .observations-container {
                overflow: hidden scroll;
                position: relative;
                flex-grow: 1;
                padding: 0 30px 0 30px;
                height: calc(100% - 730px);
                width: calc(100% - 60px);

                .observations-group-container {
                    margin-bottom: 25px;
                    .grupo-op-name {
                        position: relative;
                        display: flex;
                        padding: 15px 15px;
                        color: white;
                        background: @primary-color;
                        margin-bottom: 15px;
                        justify-content: space-between;
                        span {
                            display: inline-block;
                            vertical-align: middle;
                            font-weight: bold;
                            font-size: 2.5rem;
                        }
                    }
                    .min-observations-message {
                        font-size: 23px;
                        margin: 10px 0;
                        &.red-text {
                            color: red;
                        }
                    }
                    .obs-item-container{
                        position: relative;
                        display: grid;
                        grid-template-columns: calc(50% - 7.5px) calc(50% - 7.5px);
                        grid-column-gap: 15px;
                        padding-bottom: 25px;
                        .item-obs {
                            display: grid;
                            margin-top: 15px;
                            grid-column-gap: 5px;
                            grid-template-columns: 13% calc(90% - 5px);
                            border: solid 2px rgba(0, 0, 0, 0.3);
                            border-radius: 10px;
                            padding: 10px 15px;
                            label {
                                margin: auto 3px;
                            }
                        }
                    }
                    .typed-obs-text {
                        font-size: 32px;
                        font-family: @default-font;
                        width: 100%;
                        resize: none;
                        border: solid 2px rgba(0, 0, 0, 0.3);
                    }
                    .div-input-android {
                        position: relative;
                        display: block;
                        font-size: 32px;
                        height: 180px;
                        background-color: white;
                        color: black;
                        border: solid 2px rgba(0, 0, 0, 0.3);
                        padding: 20px;
                    }
                }

                #keyboard-filler {
                    height: 170px;
                }
            }
        }

        .prod-item-footer {
            position: relative;
            display: grid;
            grid-template-columns: auto auto;
            background: rgba(0, 0, 0, 0.1);
            height: 180px;
            border-radius: 0 0 25px 25px;

            button {
                position: relative;
                // display: block;
                margin: auto;
            }
        }
    }

    #keyboard {
        .keyboard;
        position: fixed;
        bottom: 0;
    }

    #android-keyboard {
        .keyboard;
        bottom: 60px;
        margin: auto;
    }

    .keyboard-overlay {
        z-index: 10;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet

        .obs-modal-container {
            height: calc(100vh - 150px);
            grid-template-rows: 1fr 130px;
            margin: auto 50px;

            .modal-form-container {
                .title-box {
                    height: 100px;
                    margin-bottom: 0;
                    h2 {
                        font-size: 35px;
                    }
                }

                .image-container {
                    padding: 10px;
                    img {
                        height: 250px;
                    }
                }

                .name-container {
                    margin-bottom: 20px;
                }

                .observations-container {
                    #keyboard-filler {
                        height: 150px;
                    }
                    .observations-group-container {
                        .min-observations-message {
                            font-size: 19px;
                        }
                        .grupo-op-name {
                            span {
                                font-size: 25px;
                            }
                        }
                        .obs-item-container {
                            .item-obs {
                                label {
                                    font-size: 18px;
                                }
                            }
                        }
                    }
                }
            }

            .prod-item-footer {
                height: 130px;
            }
        }

        #keyboard {
            .keyboard;
            position: fixed;
            bottom: 0;
            max-width: 760px;
            font-size: 20px;
        }
    }

@media (max-width: 698px) { // Gertec SK210

    .obs-modal-container {
        height: calc(100% - 100px);
        grid-template-rows: 1fr 70px;
        margin: auto 50px;

        .modal-form-container {
            max-width: unset;
            .title-box {
                height: 50px;
                margin-bottom: 0;
                h2 {
                    font-size: 22px;
                }
            }

            .image-container {
                padding: 15px;
                img {
                    height: 130px;
                }
            }

            .name-container {
                margin-bottom: 5px;
                text-align: center;
                h2 {
                    font-size: 22px;
                }
            }

            .observations-container {
                #keyboard-filler {
                    height: 150px;
                }
                padding: 0 15px;
                width: calc(100% - 30px);
                .observations-group-container {
                    .grupo-op-name {
                        margin-bottom: 5px;
                        padding: 5px 5px;
                        span {
                            font-size: 16px;
                        }
                    }
                    .min-observations-message {
                        font-size: 15px;
                    }
                    .obs-item-container {
                        .item-obs {
                            grid-column-gap: 0;
                            grid-template-columns: 8% auto;
                            padding: 5px 5px;
                            border-radius: 5px;
                            .container-input {
                                padding-left: 20px;
                            }
                            label {
                                padding-left: 10px;
                                font-size: 14px;
                            }
                        }
                    }
                    .div-input-android {
                        font-size: 18px;
                        height: 50px;
                        background-color: white;
                        color: black;
                        padding: 10px;
                    }
                }
            }
        }

        .prod-item-footer {
            height: 70px;
        }
    }

    #keyboard {
        .keyboard;
        position: fixed;
        bottom: 0;
        max-width: 760px;
        font-size: 20px;
    }
    #android-keyboard {
        .small-screen-keyboard;
        bottom: 30px;
    }
}

@media (orientation: landscape) {
        .obs-modal-container {
            height: calc(100vh - 120px);
            grid-template-rows: 1fr 80px;
            margin: auto 50px;
            border-radius: 10px;
            .modal-form-container {
                .title-box {
                    display: none;
                }
                .product-info-wrapper {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 5px;
                    padding: 10px 20px;
                    height: auto;
                    .image-container {
                        padding: 0px;
                        img {
                            max-height: 180px;
                            border-radius: 10px;
                        }
                    }

                    .name-container {
                        display: flex;
                        align-items: center;
                        flex-direction: row;
                        margin-bottom: unset;
                        height: 100%;
                    }
                }

                .observations-container {
                    padding: 0 15px;
                    width: auto;
                    // width: calc(100% - 10px);
                    .observations-group-container {
                        .min-observations-message {
                            font-size: 19px;
                        }
                        .grupo-op-name {
                            background-color: @primary-dark;
                            margin-left: -15px;
                            margin-right: -15px;
                            span {
                                font-size: 25px;
                            }
                        }
                        .obs-item-container {
                            grid-template-columns: calc(33% - 7.5px) calc(33% - 7.5px) calc(33% - 7.5px);
                            grid-column-gap: 15px;
                            .item-obs {
                                label {
                                    font-size: 18px;
                                }
                            }
                        }
                    }
                }
            }

            .prod-item-footer {
                height: 80px;
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
                button {
                    max-width: unset;
                    width: 40%;
                }
            }
        }
}

</style>



// WEBPACK FOOTER //
// src/components/ObservationsModalGom.vue